import { createSelector } from "reselect";
import { initialState } from "./reducer";

const selectHome = (state) => state.home || initialState;

const selectVisitedProfile = createSelector(selectHome, (state) => state.visitedProfile);

export { selectVisitedProfile };